<template>
  <a href="https://privatefootprint.com/privacy-policy" target="_blank">
    Privacy Policy
  </a>
</template>
